/**
 * SharePoint Integration Configuration
 * Centralized constants for SharePoint file sync and validation
 */

export const SHAREPOINT_CONFIG = {
  /**
   * Maximum number of files that can be synced in a single operation
   * Frontend will prevent selection of folders exceeding this limit
   */
  MAX_SYNC_FILES: 1000,

  /**
   * File extensions allowed for SharePoint import
   * Must match backend MIME type configuration
   */
  VALID_EXTENSIONS: ["pdf", "xlsx", "xls"] as const,

  /**
   * Polling interval (ms) for sync status updates
   */
  SYNC_STATUS_POLL_INTERVAL: 3000,

  /**
   * Cooldown (ms) between auto-sync triggers to prevent redundant syncs on page navigation
   */
  AUTO_SYNC_COOLDOWN: 5 * 60 * 1000,
} as const

/**
 * Check if a file extension is valid for SharePoint import
 */
export function isValidSharepointExtension(extension: string): boolean {
  return (
    SHAREPOINT_CONFIG.VALID_EXTENSIONS as readonly string[]
  ).includes(extension.toLowerCase())
}
